var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidecart-wrapper" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.sidecartOpen
          ? _c("div", {
              staticClass: "sidecart__overlay",
              on: {
                click: function($event) {
                  return _vm.$store.dispatch("cart/closeSidecart")
                }
              }
            })
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "off-canvas-right" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.sidecartOpen,
                expression: "sidecartOpen"
              },
              {
                name: "scroll-lock",
                rawName: "v-scroll-lock",
                value: _vm.sidecartOpen && _vm.isNotMobile,
                expression: "sidecartOpen && isNotMobile"
              }
            ],
            staticClass: "sidecart"
          },
          [
            _c(
              "div",
              {
                staticClass: "sidecart__header",
                class: {
                  "sidecart__header--border-bottom": !_vm.shippingPromoEnabled
                }
              },
              [
                _vm.cartIcon
                  ? _c(
                      "div",
                      { staticClass: "sidecart__icon-total-container" },
                      [
                        _c("img", {
                          staticClass: "sidecart__cart-image",
                          attrs: { src: _vm.cartIcon, alt: _vm.cartIconAlt }
                        }),
                        _vm.totalItems > 0
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "cart-bubble-quantity sidecart__header-total-badge",
                                class: _vm.colors.bubbleBg
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "cart-bubble-count sidecart__header-total-badge-count",
                                    class: [
                                      _vm.colors.bubbleText,
                                      {
                                        "cart-bubble-count--small":
                                          _vm.totalItems >= 100
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.totalItems < 100
                                          ? _vm.totalItems
                                          : "99+"
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "sidecart__icon-total-container" },
                      [
                        _c("icon", { attrs: { name: "cart", size: "30px" } }),
                        _vm.totalItems > 0
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "cart-bubble-quantity sidecart__header-total-badge",
                                class: _vm.colors.bubbleBg
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "cart-bubble-count sidecart__header-total-badge-count",
                                    class: [
                                      _vm.colors.bubbleText,
                                      {
                                        "cart-bubble-count--small":
                                          _vm.totalItems >= 100
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.totalItems < 100
                                          ? _vm.totalItems
                                          : "99+"
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                _c("h2", { staticClass: "sidecart__title" }, [
                  _vm._v("My Bag")
                ]),
                _c(
                  "button",
                  {
                    staticClass: "sidecart__close",
                    attrs: {
                      label: "Close side cart",
                      "aria-label": "Close side cart"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$store.dispatch("cart/closeSidecart")
                      }
                    }
                  },
                  [_c("icon", { attrs: { name: "close", size: "24px" } })],
                  1
                )
              ]
            ),
            _vm.shippingPromoEnabled
              ? _c(
                  "div",
                  {
                    staticClass: "sidecart__shipping-promo",
                    class: _vm.colors.shippingBg
                  },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.normalizedTotalPrice < _vm.shippingPromoTotal
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "sidecart__shipping-promo-message body-sm",
                              class: _vm.colors.shippingText
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  "Free shipping if you spend $" +
                                    _vm.remainingThresholdValue +
                                    (_vm.totalPrice === 0 ? "" : " more") +
                                    "."
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.normalizedTotalPrice >= _vm.shippingPromoTotal
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "sidecart__shipping-promo-message body-sm",
                              class: _vm.colors.shippingText
                            },
                            [_vm._v(_vm._s(_vm.shippingPromoCopy))]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.shippingPromoEnabled
              ? _c("div", {
                  staticClass: "sidecart__shipping-promo-progress-bar",
                  class: _vm.colors.shippingProgress,
                  style: { width: _vm.remainingThresholdPercentage + "%" }
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "sidecart__container" },
              [
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _vm.totalItems > 0
                    ? _c(
                        "div",
                        {
                          key: "content",
                          staticClass: "sidecart__contents-wrapper"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "sidecart__contents",
                              attrs: { id: "sidecartContents" }
                            },
                            [
                              _vm._l(_vm.itemsNotInKits, function(item, index) {
                                return _c("sidecart-line-item", {
                                  key: item.id,
                                  attrs: { item: item }
                                })
                              }),
                              _vm.kits && _vm.kits.length
                                ? _c(
                                    "div",
                                    _vm._l(_vm.kits, function(kit) {
                                      return _c("sidecart-line-item-kit", {
                                        key: kit.id,
                                        attrs: { kit: kit }
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "sidecart__footer",
                              class: _vm.enableFooterDropshadow
                                ? "footer-dropshadow-enabled"
                                : ""
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "sidecart__gift-messaging" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "sidecart__gift-messaging-header"
                                    },
                                    [
                                      _c("div", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.giftEnabled,
                                              expression: "giftEnabled"
                                            }
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "gift_message_enable"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.giftEnabled
                                            )
                                              ? _vm._i(_vm.giftEnabled, null) >
                                                -1
                                              : _vm.giftEnabled
                                          },
                                          on: {
                                            input: _vm.toggleGift,
                                            change: function($event) {
                                              var $$a = _vm.giftEnabled,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.giftEnabled = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.giftEnabled = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.giftEnabled = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "gift_message_enable"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.giftEnabled
                                                  ? "This is a Gift!"
                                                  : "Is this a Gift?"
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade" } },
                                        [
                                          _c(
                                            "v-link",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.giftEnabled,
                                                  expression: "giftEnabled"
                                                }
                                              ],
                                              staticClass:
                                                "sidecart__gift-messaging-edit body-sm",
                                              attrs: { secondary: true },
                                              on: {
                                                click: _vm.addRemoveGiftMessage
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.giftMessageEnabled
                                                    ? "Remove Message"
                                                    : "Write a Message"
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.giftEnabled &&
                                                _vm.giftMessageEnabled,
                                              expression:
                                                "giftEnabled && giftMessageEnabled"
                                            }
                                          ],
                                          staticClass:
                                            "sidecart__gift-messaging-message"
                                        },
                                        [
                                          _c(
                                            "text-area-input",
                                            {
                                              staticClass:
                                                "sidecart__gift-messaging-textarea",
                                              attrs: {
                                                "char-limit": 250,
                                                label: "Write Your Message",
                                                keydownEvent:
                                                  _vm.debouncedUpdateGiftMessage,
                                                id: "giftMessageInput"
                                              },
                                              model: {
                                                value: _vm.giftMessage,
                                                callback: function($$v) {
                                                  _vm.giftMessage = $$v
                                                },
                                                expression: "giftMessage"
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.giftMessage))]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _vm.giftMessageConfirmationActive
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "sidecart__gift-messaging-message-confirmation body-sm"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.giftMessageConfirmationMessage
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("table", { staticClass: "sidecart__table" }, [
                                _c(
                                  "tbody",
                                  { staticClass: "sidecart__table-body" },
                                  [
                                    _c(
                                      "tr",
                                      { staticClass: "sidecart__table-row" },
                                      [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "sidecart__table-data-type body-md subtotal strong-bold"
                                          },
                                          [_vm._v("Subtotal")]
                                        ),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "sidecart__table-data-price body-md subtotal"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("moneyWithoutDecimals")(
                                                  _vm.totalPrice
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm.savingsTotal !== _vm.totalPrice &&
                                    _vm.savingsTotal > 0
                                      ? _c(
                                          "tr",
                                          {
                                            staticClass: "sidecart__table-row"
                                          },
                                          [
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "sidecart__table-data-type savings body-md strong-bold"
                                              },
                                              [_vm._v("You Saved")]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "sidecart__table-data-price savings body-md"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f(
                                                      "moneyWithoutDecimals"
                                                    )(_vm.savingsTotal)
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]),
                              _c(
                                "v-button",
                                {
                                  staticClass:
                                    "sidecart__checkout-cta button button--primary",
                                  class: [
                                    {
                                      "sidecart__checkout-cta-promo-active":
                                        _vm.promoMessage
                                    }
                                  ],
                                  attrs: {
                                    full: true,
                                    type: "submit",
                                    name: "checkout",
                                    value: "Checkout",
                                    label: "CHECKOUT"
                                  },
                                  on: { click: _vm.goToCheckout }
                                },
                                [_vm._v("Checkout")]
                              ),
                              _c(
                                "v-button",
                                {
                                  staticClass:
                                    "sidecart__checkout-cta gsx-checkout__button button button--primary",
                                  class: [
                                    {
                                      "sidecart__checkout-cta-promo-active":
                                        _vm.promoMessage
                                    }
                                  ],
                                  attrs: {
                                    full: true,
                                    type: "submit",
                                    name: "international checkout",
                                    value: "Checkout",
                                    label: "INTERNATIONAL CHECKOUT"
                                  },
                                  on: { click: _vm.goToIntlCheckout }
                                },
                                [_vm._v("International Checkout")]
                              ),
                              _vm.promoMessage
                                ? _c(
                                    "div",
                                    { staticClass: "sidecart__promo" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "sidecart__promo__copy body-sm"
                                        },
                                        [_vm._v(_vm._s(_vm.promoMessage))]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _c(
                        "div",
                        { key: "empty", staticClass: "sidecart__empty" },
                        [
                          _c("p", { staticClass: "sidecart__empty__message" }, [
                            _vm._v(_vm._s(_vm.emptyText))
                          ]),
                          _vm._l(_vm.emptyLinkArray, function(link, index) {
                            return link.text
                              ? _c("v-button", {
                                  key: index,
                                  staticClass: "sidecart__empty__link",
                                  attrs: {
                                    primary: true,
                                    href: link.url,
                                    label: link.text,
                                    tag: "a"
                                  }
                                })
                              : _vm._e()
                          })
                        ],
                        2
                      )
                ])
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }